import React from 'react';
import styled from 'styled-components';

const HowItWorks = () => {
  return (
    <SectionContainer>
      <SectionTitle>Seamless Scaling</SectionTitle>
      <StepsContainer>
        <Step>
          <StepNumber>01</StepNumber>
          <StepTitle>Train Your AI Twin</StepTitle>
          <StepDescription>
            Input your coaching philosophy and communication style once.
          </StepDescription>
        </Step>
        <ConnectingLine />
        <Step>
          <StepNumber>02</StepNumber>
          <StepTitle>Create Template Programs</StepTitle>
          <StepDescription>
            Design your core workouts, nutrition guides, and habit protocols.
          </StepDescription>
        </Step>
        <ConnectingLine />
        <Step>
          <StepNumber>03</StepNumber>
          <StepTitle>Deploy Personalized Plans</StepTitle>
          <StepDescription>
            Our AI engine automatically creates custom programs for each client based on their needs.
          </StepDescription>
        </Step>
      </StepsContainer>
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  padding: 8rem 6rem;
  background-color: #F5F5F7;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (max-width: 768px) {
    padding: 6rem 2rem;
  }
`;

const SectionTitle = styled.h2`
  font-family: 'SF Pro Display', 'Satoshi', sans-serif;
  font-size: 48px;
  font-weight: 300;
  color: #1D1D1F;
  margin-bottom: 5rem;
  letter-spacing: -0.02em;
  text-align: center;
`;

const StepsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  max-width: 1200px;
  width: 100%;
  
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px;
  text-align: center;
  
  @media (max-width: 900px) {
    margin-bottom: 3rem;
  }
`;

const StepNumber = styled.div`
  font-family: 'SF Pro Display', 'Satoshi', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #BA865E;
  margin-bottom: 1.5rem;
`;

const StepTitle = styled.h3`
  font-family: 'SF Pro Display', 'Satoshi', sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #1D1D1F;
  margin-bottom: 1rem;
`;

const StepDescription = styled.p`
  font-family: 'SF Pro Text', 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #86868b;
  font-weight: 400;
`;

const ConnectingLine = styled.div`
  height: 1px;
  width: 100px;
  background-color: #DEDEDE;
  margin: 60px 20px 0;
  
  @media (max-width: 900px) {
    height: 60px;
    width: 1px;
    margin: 0 0 20px;
  }
`;

export default HowItWorks; 